import {
  SlDropdown
} from "./chunk.4ZML5342.js";

// src/components/dropdown/dropdown.ts
var dropdown_default = SlDropdown;
SlDropdown.define("sl-dropdown");

export {
  dropdown_default
};
